<template>
	<div>
		<buttonlist @help="help" @search="search" @reflash="reflash" ref="SetBtn"></buttonlist>
		<div>
			<!--<el-button type="primary" size="mini" @click="createVouch">{{$t('getapi[13374]')}}</el-button>-->
			<el-button type="primary" size="mini" @click="createVouch" :disabled="selectData.length == 0">{{$t('getapi[13374]')}}</el-button>
		</div>
		<vxe-table
				id="xpane-0"
				:data="datajson"
				v-loading="loading"
				:highlight-current-row="false"
				show-overflow-tooltip="true"
				border
				stripe
				size="mini"
				header-row-class-name="headerclass"
				:height="tableHeight"
				@cell-dblclick="editInfo"
				tab-click="selectInfo(0)"
				@checkbox-change="handleSelectionChange"
				:span-method="handleSpanMethod"
				style="width: 100%; margin-top:0px"
				:header-cell-style="$limits.headerClass"
				ref="singleTable"
		>
			<vxe-table-column align="center" type="checkbox" width="40"></vxe-table-column>
			<vxe-table-column show-overflow-tooltip field="order_type_flag" :title="$t('getapi[2446]')"></vxe-table-column>
			<vxe-table-column show-overflow-tooltip field="order_no" :title="$t('getapi[7093]')"></vxe-table-column>
			<vxe-table-column show-overflow-tooltip field="create_date" :title="$t('getapi[7576]')"></vxe-table-column>
			<vxe-table-column show-overflow-tooltip field="subjectcode" :title="$t('getapi[13424]')"></vxe-table-column>
			<vxe-table-column show-overflow-tooltip field="subjectdirection" :title="$t('getapi[13425]')"></vxe-table-column>
			<vxe-table-column show-overflow-tooltip field="borrow_amount" :title="$t('getapi[13426]')" align="right"></vxe-table-column>
			<vxe-table-column show-overflow-tooltip field="loan_amount" :title="$t('getapi[13427]')" align="right"></vxe-table-column>
			<vxe-table-column show-overflow-tooltip field="part_code" :title="$t('getapi[112]')"></vxe-table-column>
			<vxe-table-column show-overflow-tooltip field="vendercode" :title="$t('getapi[1196]')"></vxe-table-column>
			<vxe-table-column show-overflow-tooltip field="vender_name" :title="$t('getapi[1197]')"></vxe-table-column>
			<vxe-table-column show-overflow-tooltip field="customer_id" :title="$t('getapi[2953]')" ></vxe-table-column>
			<vxe-table-column show-overflow-tooltip field="customer_name" :title="$t('getapi[2958]')"></vxe-table-column>
			<vxe-table-column show-overflow-tooltip field="item_code" :title="$t('getapi[1288]')"></vxe-table-column>
			<vxe-table-column show-overflow-tooltip field="item_name" :title="$t('getapi[546]')"></vxe-table-column>
		</vxe-table>
		<!-- 搜索弹框 -->
		<serce :isVisible="isVisible" queryData="ENGITEMLineViewInfo" ref="ser" @getser="serclick"></serce>

		<el-dialog v-dialogDrag :visible.sync="isVisible" :title="$t('getapi[3653]')" width="30%" :close-on-click-modal="false">
			<el-tabs type="border-card">
				<el-tab-pane :label="$t('getapi[2020]')">
					<el-table :data="queryData" border height="400" size="mini" style="width: 100%;" header-row-class-name="headerclass">
						<el-table-column show-overflow-tooltip prop="Field_Show_Name" :label="$t('getapi[2021]')"
										 width="150"></el-table-column>
						<el-table-column :label="$t('getapi[2022]')">
							<template slot-scope="scope">
								<input type="text" v-model="scope.row.query_Condition" style="border:none"/>
							</template>
						</el-table-column>
					</el-table>
				</el-tab-pane>
			</el-tabs>

			<span slot="footer" class="dialog-footer">
				<el-button @click="isVisible = false">{{ $t('getapi[6]') }}</el-button>
				<el-button type="primary" @click="intidata">{{ $t('getapi[1146]') }}</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
    import Common from '@/components/Common';

    export default {
        name: '3_costcreatevouch',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight3 - Common.reduceTableHeight2
            }
        },
        data() {
            return {
                isVisible: false,
                DbTbNames: '', //表名
                datajson: [],
                PageIndex: 1,
                PageSize: this.$http.getPageSize('3_costcreatevouch'),
                SelectIndex: 1,
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                queryData: [{
                    Field_Show_Name:'业务类型',
                    query_Condition:'',
				},{
                    Field_Show_Name:'单据号',
                    query_Condition:'',
                }], // 查询数组
                selectData: [],
                userData: [],
                user: '',
                scrollTop:0,

            };
        },
        create() {
        },
        beforeMount() {
            console.log('beforeMount');
            //this.getqwlist();
        },
        watch: {
            datajson: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(0)
                })
            },
        },
        mounted() {
            console.log('mounted');
            let that = this;
            that.userData = sessionStorage.getItem('userData');
            that.user = JSON.parse(that.userData).username;
            that.intidata();
            that.authority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[1091]"),this.$t("getapi[11]"));
            },
            //按钮操作权限
            authority() {
                let that = this;
                that.$refs.SetBtn.SetButtonEnable('search,refresh');
            },
            handleSpanMethod({ row, $rowIndex, column, data }) {
                // 找出相同 order_no 的行索引
                const sameOrderRows = data
                    .map((item, index) => item.order_no === row.order_no ? index : -1)
                    .filter(index => index !== -1)

                // 如果是相同 order_no 的第一行
                const isFirstRow = $rowIndex === sameOrderRows[0]
                const isSameOrderRow = sameOrderRows.includes($rowIndex)

                // 需要合并的列类型
                const isMergeColumn = column.type === 'checkbox' || column.property === 'order_no'

                if (isSameOrderRow && isMergeColumn) {
                    return {
                        rowspan: isFirstRow ? sameOrderRows.length : 0,
                        colspan: 1
                    }
                }

                // 其他列不合并
                return {
                    rowspan: 1,
                    colspan: 1
                }
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.intidata();
                this.authority();
            },
            //编辑
            editInfo(row) {
                let that = this;
            },
            // 获取数据
            intidata() {
                let that = this;
                that.loading = true;
                this.isVisible = false;
                let parm = {
                    ordertypeflag:null,
					orderno:null,
                };
                for (let i = 0; i < that.queryData.length; i++) {
                    if(that.queryData[i].Field_Show_Name == '业务类型'){
                        parm.ordertypeflag = that.queryData[i].query_Condition == ''? null :that.queryData[i].query_Condition
                    }
                    if(that.queryData[i].Field_Show_Name == '单据号'){
                        parm.orderno = that.queryData[i].query_Condition== ''? null :that.queryData[i].query_Condition
                    }
                }
                that.$http.urlpost('GL/Cost/GetAllocatedData', parm, function (res) {
                    console.log(res);
                    if (res.Success == 1) {
                        that.datajson = res.DataContent;
                        that.total = res.Totals;
                        that.DbTbNames = res.DbTbNames;
                    }
                    that.loading = false;
                    that.authority();
                });
            },
            // 获取查询条件
            getqwlist() {
                let that = this;
                that.$http.urlpost('Basic/Items/ItemQWList', {}, function (res) {
                    that.queryData = res.DataContent;
                });
            },

            handleSelectionChange({checked, records }) {
                let that = this;
                that.selectData = records
            },
            // 查询
            search() {
                let that = this
                that.isVisible = true
            },
            // 刷新
            reflash() {
                this.intidata();
            },
            beforeRoutJump(val,callback){
                let that = this
                if(that.oldFormInline != JSON.stringify(that.formInline)){
                    this.$confirm(that.$t('getapi[12830]'), that.$t('getapi[194]'), {
                        confirmButtonText: that.$t('getapi[1146]'),
                        cancelButtonText: that.$t('getapi[2054]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.isVisible = false
                            callback(true)
                        })
                        .catch(() => {
                            this.$message({
                                type: 'info',
                                message: that.$t('getapi[6096]')
                            });
                        });
                } else {
                    that.isVisible = false
                    callback(true)
                }
            },
			createVouch(){
                let that = this
				console.log(that.selectData)
				let arr = []
				for(let i=0;i<that.datajson.length;i++){
				    for(let j=0;j<that.selectData.length;j++){
				        if(that.datajson[i].order_no == that.selectData[j].order_no){
				            arr = [...arr,that.datajson[i]]
						}
					}
				}
				let parm = arr
                that.$http.urlpost('GL/Cost/CreateCostVouch', parm, function (res) {
                    console.log(res);
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.intidata()
                    }
                })
			},
        }
    };
</script>

<style lang="scss" scoped>

	table {
		border-collapse: separate;
		border-spacing: 0px 5px;
		td {
			padding-left: 3px;
			white-space: pre;
		}
	}
</style>
